import { render, staticRenderFns } from "./responsibilityModal.vue?vue&type=template&id=cf09ea38&scoped=true&"
import script from "./responsibilityModal.vue?vue&type=script&lang=js&"
export * from "./responsibilityModal.vue?vue&type=script&lang=js&"
import style0 from "./responsibilityModal.vue?vue&type=style&index=0&id=cf09ea38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf09ea38",
  null
  
)

export default component.exports